
import React, { useState, useEffect } from 'react';
// import './ReviewView.css'; // Use shared Theme.css instead

const ReviewView = ({
    initialText,
    reviewResult,
    onAnalyze,
    onSave,
    onCancel,
    analyzing,
    isInline = false,
    isManual = false
}) => {
    // Local state for form editing
    const [mode, setMode] = useState(isInline || isManual ? 'manual' : 'ai');
    const [formData, setFormData] = useState(reviewResult || {});
    const [text, setText] = useState(initialText);

    // Initialization logic from previous version
    useEffect(() => {
        if (isInline || isManual) {
            setMode('manual');
            if (isManual) {
                setFormData({});
            }
        }
    }, [isInline, isManual]);

    useEffect(() => {
        if (reviewResult) setFormData(reviewResult);
    }, [reviewResult]);

    // Mode switching logic (simplified)
    useEffect(() => {
        if (mode === 'manual') {
            if (!Object.keys(formData).length) {
                // If switching to manual and empty, maybe clear?
                // But we want to preserve if we just keyed it in.
                // Keeping logic simple: if empty and manual, ensure it's usable.
                // Actually, the original logic was setFormData({}).
                // Let's keep it but suppress warning about formData dependency which causes loops.
            }
        } else {
            if (reviewResult) setFormData(reviewResult);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mode, reviewResult]);

    const handleSave = () => {
        // Strict ID preservation: Merge original result into form data to ensure ID is present
        const dataToSave = { ...reviewResult, ...formData };
        onSave(dataToSave, text);
    };

    const handleInputChange = (field, value) => {
        setFormData(prev => ({ ...prev, [field]: value }));
    };

    // Render as Modal
    return (
        <div className="modal-overlay" onClick={(e) => { if (e.target === e.currentTarget) onCancel(); }}>
            <div className="modal-card">
                <h3 className="modal-title">{isManual ? 'New Transaction' : 'Review Transaction'}</h3>

                {/* Text Source / Note */}
                <div className="form-group">
                    <label>{isManual ? 'Note (Optional)' : 'Original SMS / Description'}</label>
                    <textarea
                        className="modern-input"
                        style={{ height: '80px', resize: 'none', opacity: isManual ? 1 : 0.7 }}
                        value={text}
                        onChange={e => setText(e.target.value)}
                        placeholder={isManual ? "e.g. Paid for dinner at ..." : "SMS Body"}
                        disabled={!isManual}
                    // Enable AI button if in AI mode?
                    />
                    {mode === 'ai' && !reviewResult && (
                        <button
                            onClick={() => onAnalyze(text)}
                            className="btn-primary"
                            style={{ marginTop: '10px', padding: '10px' }}
                            disabled={analyzing || !text}
                        >
                            {analyzing ? 'Analyzing...' : 'Analyze with AI'}
                        </button>
                    )}
                </div>

                {/* Form Fields - Show if manual or analysis done */}
                {(mode === 'manual' || (mode === 'ai' && reviewResult)) && (
                    <>
                        <div className="form-group">
                            <label>Merchant / Title</label>
                            <input
                                type="text"
                                className="modern-input"
                                value={formData.merchant || ''}
                                onChange={e => handleInputChange('merchant', e.target.value)}
                            />
                        </div>

                        <div className="form-row">
                            <div className="form-group">
                                <label>Amount (₹)</label>
                                <input
                                    type="number"
                                    className="modern-input"
                                    value={formData.amount || ''}
                                    onChange={e => handleInputChange('amount', parseFloat(e.target.value))}
                                />
                            </div>
                            <div className="form-group">
                                <label>Date</label>
                                <input
                                    type="date"
                                    className="modern-input"
                                    value={formData.date ? formData.date.split('T')[0] : ''}
                                    onChange={e => handleInputChange('date', e.target.value)}
                                />
                            </div>
                        </div>

                        <div className="form-row">
                            <div className="form-group">
                                <label>Type</label>
                                <select
                                    className="modern-input"
                                    value={formData.transaction_type || 'OUTFLOW'}
                                    onChange={e => handleInputChange('transaction_type', e.target.value)}
                                >
                                    <option value="OUTFLOW">Expense</option>
                                    <option value="INFLOW">Income</option>
                                </select>
                            </div>
                            <div className="form-group">
                                <label>Category</label>
                                <select
                                    className="modern-input"
                                    value={formData.category || 'General'}
                                    onChange={e => handleInputChange('category', e.target.value)}
                                >
                                    <option value="Food">Food</option>
                                    <option value="Travel">Travel</option>
                                    <option value="Bills">Bills</option>
                                    <option value="Shopping">Shopping</option>
                                    <option value="Health">Health</option>
                                    <option value="Entertainment">Entertainment</option>
                                    <option value="Investment">Investment</option>
                                    <option value="Salary">Salary</option>
                                    <option value="General">General</option>
                                </select>
                            </div>
                        </div>
                    </>
                )}

                <div className="modal-actions">
                    <button className="btn-primary" onClick={handleSave}>Confirm & Save</button>
                    <button className="btn-secondary" onClick={onCancel}>Cancel</button>
                </div>
            </div>
        </div>
    );
};

export default ReviewView;
